import { BrowserClient, Hub } from "@sentry/browser";

const log = new BrowserClient({
  dsn: process.env.VUE_APP_SENTRY_URL,
  environment: process.env.NODE_ENV
});

function logError(error) {
  console.log(error);
  const hub = new Hub(log);

  hub.captureException(error);
}

export { logError };
